import apiClient from '@/services/api';
import { useAuthStore } from '@/stores/auth';

const API_URL = '/commission_wages';

const sanitizeCommissionWagesData = (commissionWagesData) => {
  const data = { ...commissionWagesData }; // Create a shallow copy to avoid mutating original
  const authStore = useAuthStore();
  data.company_id = data.company_id || authStore.currentUser?.company_id;

  // Ensure numeric fields are numbers
  if (data.commission_split_percentage) data.commission_split_percentage = Number(data.commission_split_percentage);
  if (data.employee_id) data.employee_id = Number(data.employee_id);
  if (data.company_id) data.company_id = Number(data.company_id);
  if (data.amount) data.amount = Number(data.amount);

  // Normalise enums to backend's exact casing
  if (data.payment_method) data.payment_method = data.payment_method.toLowerCase();   // check | cash | wire_transfer …
  if (data.status) data.status = data.status.toLowerCase();   // paid | pending | voided …

  return data;
};

export default {
  async getCommissionWages() {
    const authStore = useAuthStore();
    const userCompanyId = authStore.currentUser?.company_id;
    
    // Build URL with company filter if user has a company_id
    let url = '/commission_wages';
    if (userCompanyId) {
      const filter = {"field":"company_id","value":userCompanyId};
      url += `?filter=${encodeURIComponent(JSON.stringify(filter))}`;
    }
    
    return (await apiClient.get(url)).data;
  },
  async getCommissionWage(id)           { const r = await apiClient.get(`${API_URL}/${id}`); return r.data; },
  async createCommissionWage(data)      { const r = await apiClient.post(API_URL, sanitizeCommissionWagesData(data)); return r.data; },
  async updateCommissionWage(id, data)  { const r = await apiClient.put(`${API_URL}/${id}`, sanitizeCommissionWagesData(data)); return r.data; },
  async deleteCommissionWage(id)        { return apiClient.delete(`${API_URL}/${id}`); }
};
